import React from 'react';

const Divider = () => {
  return (
    <div className="divider">
      <div className="line"></div>
    </div>
  );
};

export default Divider;